<template>
    <div id="progressbg" class="progressbg">
        <div id="animatepart" class="animatepart">
            <toolbox 
                v-for="(eachtext, index) in text"
                :key="index"
                :eachtext="eachtext"
                :hint="'blackg+'"
            >
            </toolbox>
            <div class="responsepart">
                <div class="response">
                    <div class="responsetitle">
                        邀請您，一同響應！
                    </div>
                    <div class="responsetext">
                        在台灣各個角落，都有一群人正為這座島嶼的未來而努力，您的支持，能讓改變持續發生。邀請您，一同響應！不論是企業贊助、民間合作、提供資源，讓我們一起攜手，共創更美好的台灣未來。
                    </div>
                </div>
            </div>
            <div class="buttonpart">
                <div class="button" @click="clickbutton">
                    <div class="buttontext">
                        我要響應
                    </div>
                    <img src="https://p3.udn.com.tw/wish/images/common/botton_support.svg" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { sendGaMethods } from '@/assets/js/utils/masterBuilder.js';
    import toolbox from '@/components/common/toolbox.vue'
    export default {
        mixins: [sendGaMethods],
        data(){
            return{
                
            }
        },
        props: {
            text: { type: Array },
        },
        created () {
            window.addEventListener('scroll', this.onScroll);
        },
        destroyed () {
            window.removeEventListener('scroll', this.onScroll);
        },
        mounted(){
            
        },
        components: {
            toolbox
        },
        methods:{
            onScroll(){
                if(document.getElementById("progressbg").getBoundingClientRect().top<window.innerHeight-200){
                    document.getElementById("animatepart").style.opacity=1;
                    document.getElementById("animatepart").style.transform="translateY(0)";
                }
            },
            clickbutton(){
                window.open("https://docs.google.com/forms/d/e/1FAIpQLScA49vvk8CUnFsAxK7OqXZ9XBbP8sQ_-a0l9UuB0_WZGzp4mQ/viewform", '_blank');
                this.sendGA({category: 'plus_one_button', action: 'click', label: "click_plus_one_button_"+this.$store.state.currentwisher});
            },
        },
    }
</script>

<style lang="scss" scoped>
.progressbg{
    position: relative;
    width: 100%;
    padding-bottom: 50px;
    background-color: #1D1C1B;
    .animatepart{
        opacity: 0;
        transform: translateY(100px);
        transition: .5s;
        div + div {
            padding-top: 30px;
        }
        .responsepart{
            position: relative;
            margin: auto;
            width: 92.27%;
            max-width: 768px;
            padding: 30px 0 30px 0;
            display: flex;
            justify-content: center;
            align-items: center;
            @media (min-width: 768px) AND (max-width: 960px) {
                max-width: 576px;
            }
            @media (min-width: 960px) {
                max-width: 720px;
            }
            .response{
                position: relative;
                width: 100%;
                max-width: 720px;
                .responsetitle{
                    color: #E1E1E1;
                    font-size: 24px;
                    line-height: 36px;
                    font-weight: bold;
                    margin-top: 30px;
                    font-family: 'Noto Serif TC';
                    @media (min-width: 768px) AND (max-width: 960px) {
                        font-size: 24px;
                        line-height: 36px;
                        margin-top: 50px;
                    }
                    @media (min-width: 960px) {
                        font-size: 30px;
                        line-height: 40px;
                        margin-top: 50px;
                    }
                }
                .responsetext{
                    color: #E1E1E1;
                    font-size: 20px;
                    line-height: 35px;
                    opacity: 0.8;
                    font-weight: 300;
                    font-family: 'Noto Serif TC';
                }
            }
        }
        .buttonpart{
            position: relative;
            margin: auto;
            width: 90%;
            padding: 30px 0 0px 0;
            display: flex;
            justify-content: center;
            align-items: center;
            .button{
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                @media (hover: hover) {
                    img:hover{
                        content: url('https://p3.udn.com.tw/wish/images/common/botton_support_hover.svg');
                    }
                }
                .buttontext{
                    position: absolute;
                    font-size: 15px;
                    line-height: 24px;
                    font-weight: 300;
                    color: #FAFAFA;
                    font-family: 'Noto Sans TC';
                }
            }
        }
    }
}
</style>